import { render, staticRenderFns } from "./AcceptTalentsOffer.htm?vue&type=template&id=67dff0f4&scoped=true&"
import script from "./AcceptTalentsOffer.ts?vue&type=script&lang=js&"
export * from "./AcceptTalentsOffer.ts?vue&type=script&lang=js&"
import style0 from "./AcceptTalentsOffer.scss?vue&type=style&index=0&id=67dff0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dff0f4",
  null
  
)

export default component.exports